const YoutubePlayIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="39"
      height="28"
      viewBox="0 0 39 28"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0_425_815)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M38.6105 5.86392C38.6105 5.86392 38.2295 3.20072 37.0601 2.02794C35.5771 0.488682 33.9147 0.481039 33.1524 0.390953C27.6949 0 19.5084 0 19.5084 0H19.4915C19.4915 0 11.3052 0 5.8475 0.390953C5.08514 0.481039 3.42342 0.488682 1.93986 2.02794C0.770531 3.20072 0.390019 5.86392 0.390019 5.86392C0.390019 5.86392 0 8.99139 0 12.1188V15.0508C0 18.1782 0.390019 21.3056 0.390019 21.3056C0.390019 21.3056 0.770531 23.9689 1.93986 25.1417C3.42342 26.681 5.37218 26.6323 6.24015 26.7936C9.36019 27.0901 19.5 27.1818 19.5 27.1818C19.5 27.1818 27.6949 27.1696 33.1524 26.7787C33.9147 26.6886 35.5771 26.681 37.0601 25.1417C38.2295 23.9689 38.6105 21.3056 38.6105 21.3056C38.6105 21.3056 39 18.1782 39 15.0508V12.1188C39 8.99139 38.6105 5.86392 38.6105 5.86392Z"
          fill="#343434"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.4735 18.3814L15.4717 7.74506L26.108 13.0818L15.4735 18.3814Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_425_815">
          <rect width="39" height="27.1818" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default YoutubePlayIcon;
